const smallSizeDefaults = {
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
  iconSize: [12, 20],
  iconAnchor: [6, 20],
  popupAnchor: [1, -34],
  shadowSize: [20, 20]
}

const normalSizeDefaults = {
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
}

const makeIcon = (color, sizeOptions) => {
  return new window.L.Icon({
    iconUrl: `https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-${color}.png`,
    ...sizeOptions
  });
}

const smallBlueIcon = makeIcon('blue', smallSizeDefaults)
const greenIcon = makeIcon('green', normalSizeDefaults)
const smallGreenIcon = makeIcon('green', smallSizeDefaults)

export {
  smallBlueIcon,
  greenIcon,
  smallGreenIcon
}